import { iniciarForms, readURL, addCerrar, ponerCaptchaModal, validateUser, jSONInfo, obtenerOffsetMenu, setDefaults } from '../js/utils.js'
import { crearModals, crearModalsDataHidden, mandatoryModals, crearGenModal } from '../js/modals.js'

import '../libs/chosen_v1.8.7/chosen.jquery.js'

// modernizr
import '../libs/modernizr/modernizr-custom.js'

// autocomplete
import '../libs/autocomplete/jquery.autocomplete.js'


let $search_ac, heightHeader = 0;
$(document).ready(function() { 
	setDefaults()

	$('select').formSelect();
	$('.sidenav').sidenav();
	
		/* Pone la imagen seleccionada */
	$('[type="file"]').change(function (event){
		let $imagen = $(this).parents('form').find('[data-id="' + $(this).attr('name') + '"]')
		readURL(this, $imagen);
	});

	$('[href="/logout/"]').on('click',function(event){
		event.stopPropagation();
		event.preventDefault();
		var config  = {action:'/logout/', type:'POST'};

		$.ajax({
			url: '/logout/', 
			type: 'POST', 
			success: function(data){
				window.location     = '/';
			}
		});
	});

	// AHORA REVISAMOS
	$('.modal:not(.propio)').modal({
		dismissible: false,
		onOpenStart: function (modal, trigger) {
			var $modal		= $(modal)
			, $trigger     	= $(trigger)
			addCerrar(modal);
			ponerCaptchaModal($modal)
			iniciarForms($modal.find('form'))

			// Para traer productos de un carrito previo - perfil finaliza proceso
			switch(modal.id){
				case 'prevlist':
					let code	= trigger.dataset.code
					,	$boton 	= $(modal).find('[data-send]')
					$boton.attr('data-disable', 'true')
					informacionListaAnterior(code, function(calculos){
						ponerSoloItems($(modal).find('.items-lista'), calculos.carrito);
						$boton.attr('data-disable', 'false')
					})
					break;
			}
		},
		onOpenEnd: function (modal, trigger) {
			let form = $(modal).find('form');
			M.updateTextFields();

		},
		onCloseEnd: function (modal) {
			let $modal = $(modal);
		}	
	});
	
	iniciarForms()

	/** Si el menú es muy extenso */
	//arreglarMenu()
	//$('.dropdown-trigger').dropdown({alignment: 'right', hover: !window.mobileAndTabletCheck(), coverTrigger: false, constrainWidth: false, container: $('body')});

	/** Restricciones de números */
	$("body").on("keydown", '[data-numbers="true"], [type="number"][min="1"], [type="number"][min="0"]', function(event){
			let key = event.charCode || event.keyCode || 0;
	            // allow backspace, tab, delete, enter, arrows, numbers and keypad numbers ONLY
	            // home, end, period, and numpad decimal
	            return (
	                key == 8 || 
	                key == 9 ||
	                key == 13 ||
	                key == 46 ||
	                key == 110 ||
	                key == 190 ||
	                (key >= 35 && key <= 40) ||
	                (key >= 48 && key <= 57) ||
	                (key >= 96 && key <= 105));
		})


	

	/** Scroll */
	heightHeader = $('header.mainheader').outerHeight();
	$('.header-replace').css({'height': heightHeader + 'px', 'display': 'none'})
	function debounce(method, delay) {
	    clearTimeout(method._tId);
	    method._tId= setTimeout(function(){
	        method();
	    }, delay);
	}

	$(window).scroll(function() {
	    debounce(handleScroll, 180);
	});

	if(autoLogin){
		let clogin = M.Modal.getInstance($('#clogin').get(0));
		clogin.options.opacity = .9
		clogin.open();
	}

});

function handleScroll(data){
	if(document.documentElement.scrollTop > heightHeader){
		estadoHeader(true)
	}
	else{
		estadoHeader(false)
	}
}

function estadoHeader(fixed){
	if(fixed){
		if($('header.mainheader').hasClass('floating')) return;
		$('.header-replace').css('display', 'block')
		$('header.mainheader').addClass('floating')
		$('header.mainheader').css({top: -heightHeader, opacity: 0.25})
							.animate({top: 0, opacity: 1}, 180, function() {});		
	}
	else{
		if(!$('header.mainheader').hasClass('floating')) return;
		$('.header-replace').css('display', 'none')
		$('header.mainheader').removeClass('floating')		
	}
}

function arreglarMenu(){
	let $menuOtros  = $('<ul id="otro-menu" class="dropdown-content">')
	,	$menu 		= $('#menu')
	,	$_dots 	= $('<li class="tab dots"><a class="dropdown-trigger" href="#!"><i class="material-icons">more_vert</i></a></li>')
	$('body').append($menuOtros)
	$menu.prepend($_dots)

	let elementos 	= obtenerOffsetMenu($menu.get(0));
	$_dots.remove()
	if(elementos == undefined) 	return;
	if(elementos.length == 0) 	return;

	for(let el in elementos){
		let $_subMenu = $(elementos[el]).find('a').clone()
		$('<li />').append($_subMenu).appendTo($menuOtros)
		$(elementos[el]).remove()
	}	
	$menu.append('<li class="tab"><a class="dropdown-trigger" href="#!" data-target="otro-menu"><i class="material-icons">more_vert</i></a></li>')
}

window.setTexto = function (ix){
	return x_textos[ix] == undefined ? '' : x_textos[ix]
}

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

String.prototype.format = function() {
    var formatted = this;
    for (var i = 0; i < arguments.length; i++) {
        var regexp = new RegExp('\\{'+i+'\\}', 'gi');
        formatted = formatted.replace(regexp, arguments[i]);
    }
    return formatted;
}


// WEBPACK FOOTER //
// ./src/js/general.js